<cm-header-popup (closeDialogEmitter)="onCloseDialog()">
  <div class="header-popup__paragraph">
    <h2 class="header-popup__title">{{ 'help.needHelp' | translate }}</h2>
    <p class="header-popup__content">{{ 'help.helpGuide' | translate }}</p>
  </div>
  <div class="header-popup__paragraph">
    <h2 class="header-popup__title--week">{{ 'help.mondayToFriday' | translate }}</h2>
    <p class="header-popup__content">{{ 'help.availableHours' | translate }}</p>
  </div>

  <div class="header-popup__content">
    <div class="header-popup__content__section">
      <mat-icon class="material-icons-outlined my-0 ml-0">call</mat-icon>
      <span> {{ 'help.phone' | translate }} </span>
    </div>
    <div class="header-popup__content__section">
      <mat-icon class="material-icons-outlined my-0 ml-0">mail</mat-icon>
      <span> {{ 'help.email' | translate }} </span>
    </div>
  </div>
</cm-header-popup>
